export enum EEnsoleillement {

    RiviereCouverte90pc = 1,
    RiviereAssezCouverte50a90pc = 2,
    RiviereAssezDegagee10a50pc = 3,
    RiviereDegagee10pc = 4
}
